// extracted by mini-css-extract-plugin
module.exports = {"subContainer1":"ChatDropdown_subContainer1__2L0-l","label":"ChatDropdown_label__2Xsui","changeDiv":"ChatDropdown_changeDiv__3f0Ut","addBlurr":"ChatDropdown_addBlurr__3xNPj"};